<template>
<div class="orders-view-multi-select-panel">
    <div class="flex align-center bold mb5">
        <div class="flex-fill">Selección Múltiple ({{ selectedCount }})</div>
        <i class="options icon-cross" @click="$emit('clear-all')" title="Deseleccionar Todo"></i>
    </div>
    <div class="flex-fill ofy">
        <div
            v-for="row in previewRows"
            :key="'tm-' + row.id"
            class="well flex align-center mb5 secondary-text pa10"
        >
            <span class="flex-fill">#{{ row.id_ticket != null ? row.id_ticket : '—' }}</span>
            <i
                class="icon icon-cross ml5 selectable"
                title="Quitar de la selección"
                @click.stop.prevent="$emit('remove-row', row)"
            ></i>
        </div>
    </div>
    <button
        class="secondary selected-color mt5"
        v-if="showComplete"
        @click="$emit('complete')"
    >
        Completar Pedidos
    </button>
    <button
        class="secondary justify-center mt5"
        v-if="showSend"
        @click="$emit('send')"
    >
        Enviar Pedidos
    </button>
    <button
        class="secondary error-color justify-center mt5"
        v-if="showCancel"
        @click="$emit('cancel')"
    >
        Cancelar Pedidos
    </button>
</div>
</template>

<script>
export default {
    name: 'OrdersViewMultiSelectPanel',
    props: {
        previewRows: {
            type: Array,
            default: () => []
        },
        selectedCount: {
            type: Number,
            default: 0
        },
        showComplete: {
            type: Boolean,
            default: false
        },
        showSend: {
            type: Boolean,
            default: false
        },
        showCancel: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped lang="scss">
.orders-view-multi-select-panel {
    flex-shrink: 0;
    padding: 10px;
    display: flex;
    flex-direction: column;
    min-width: 300px;
    max-width: 300px;
    width: 300px;
    overflow: auto;
    align-self: stretch;
    background-color: var(--white);
    border-left: 1px solid var(--gray-2);
    box-sizing: border-box;

    > .flex-fill.ofy {
        min-height: 0;
    }
}
</style>

<style lang="scss">
.dark .orders-view-multi-select-panel {
    background-color: var(--dark-bg-1);
    border-left: 5px solid var(--dark-bg);
}
</style>
